export const CacheBucketIdEnum = {
    DASHBOARD: 'dashboard',
};
